<script context="module"></script>

<script>import { afterUpdate, onMount } from "svelte";
import { TARGET } from "../../constants/target";
import { handleABTestingSync } from "../../helpers/ab-tests";
import { getDefaultCanTrack } from "../../helpers/canTrack";
import ContentComponent from "../content/content.svelte";
import InlinedScript from "../inlined-script.svelte";
import InlinedStyles from "../inlined-styles.svelte";
import { checkShouldRenderVariants, getInitVariantsFnsScriptString, getUpdateCookieAndStylesScript, getVariants, } from "./helpers";
export let canTrack = undefined;
export let content = undefined;
export let isNestedRender = undefined;
export let nonce = undefined;
export let model = undefined;
export let data = undefined;
export let context = undefined;
export let apiKey;
export let apiVersion = undefined;
export let customComponents = undefined;
export let linkComponent = undefined;
export let locale = undefined;
export let enrich = undefined;
export let blocksWrapper = undefined;
export let blocksWrapperProps = undefined;
export let contentWrapper = undefined;
export let contentWrapperProps = undefined;
export let trustedHosts = undefined;
$: updateCookieAndStylesScriptStr = () => {
    return getUpdateCookieAndStylesScript(getVariants(content).map((value) => ({
        id: value.testVariationId,
        testRatio: value.testRatio,
    })), content?.id || "");
};
$: hideVariantsStyleString = () => {
    return getVariants(content)
        .map((value) => `.variant-${value.testVariationId} { display: none; } `)
        .join("");
};
$: defaultContent = () => {
    return shouldRenderVariants
        ? {
            ...content,
            testVariationId: content?.id,
        }
        : handleABTestingSync({
            item: content,
            canTrack: getDefaultCanTrack(canTrack),
        });
};
let shouldRenderVariants = checkShouldRenderVariants({
    canTrack: getDefaultCanTrack(canTrack),
    content: content,
});
onMount(() => {
    /**
     * For Solid/Svelte: we unmount the non-winning variants post-hydration.
     */
    shouldRenderVariants = false;
});
afterUpdate(() => { });
</script>

{#if !isNestedRender && TARGET !== "reactNative"}
  <InlinedScript
    id="builderio-init-variants-fns"
    scriptStr={getInitVariantsFnsScriptString()}
    nonce={nonce || ""}
  />
{/if}

{#if shouldRenderVariants}
  <InlinedStyles
    id="builderio-variants"
    styles={hideVariantsStyleString()}
    nonce={nonce || ""}
  />
  <InlinedScript
    id="builderio-variants-visibility"
    scriptStr={updateCookieAndStylesScriptStr()}
    nonce={nonce || ""}
  />

  {#each getVariants(content) as variant (variant.testVariationId)}
    <ContentComponent
      {isNestedRender}
      {nonce}
      content={variant}
      showContent={false}
      {model}
      {data}
      {context}
      {apiKey}
      {apiVersion}
      {customComponents}
      {linkComponent}
      {canTrack}
      {locale}
      {enrich}
      isSsrAbTest={shouldRenderVariants}
      {blocksWrapper}
      {blocksWrapperProps}
      {contentWrapper}
      {contentWrapperProps}
      {trustedHosts}
    />
  {/each}
{/if}
<ContentComponent
  {nonce}
  {isNestedRender}
  {...{}}
  content={defaultContent()}
  showContent={true}
  {model}
  {data}
  {context}
  {apiKey}
  {apiVersion}
  {customComponents}
  {linkComponent}
  {canTrack}
  {locale}
  {enrich}
  isSsrAbTest={shouldRenderVariants}
  {blocksWrapper}
  {blocksWrapperProps}
  {contentWrapper}
  {contentWrapperProps}
  {trustedHosts}
/>